import type { TerminalProfileAdditionalAmountHandlingDto } from "src/app/features/TerminalProfile/types/subTypes/TerminalProfileAdditionalAmountHandlingDto";
import type { TerminalProfileMerchantReferenceNumberDto } from "src/app/features/TerminalProfile/types/subTypes/TerminalProfileMerchantReferenceNumberDto";
import type { TerminalConfigurationDto } from "src/app/features/TerminalProfile/types/TerminalConfigurationDto";
import { extractNestedObject } from "../../../../../core/utils/utilFunctions";
import type { TerminalProfileDto } from "../../types/TerminalProfileDto";
import type { TerminalProfileEntity } from "../../types/TerminalProfileEntity";

export const TerminalProfileEntityToDto = ({ dynamicProperties, ...rest }: Readonly<TerminalProfileEntity>): TerminalProfileDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "TEXT" ? propValue.value || "" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern ?? "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    const terminalConfigurationDto = extractNestedObject<TerminalConfigurationDto>(rest, "terminalConfiguration");

    // Extract nested objects for the specified prefixes using util function with proper generics
    const merchantReference1Dto = extractNestedObject<TerminalProfileMerchantReferenceNumberDto>(rest, "merchantReferenceNumber1");
    const merchantReference2Dto = extractNestedObject<TerminalProfileMerchantReferenceNumberDto>(rest, "merchantReferenceNumber2");
    const tipHandlingDto = extractNestedObject<TerminalProfileAdditionalAmountHandlingDto>(rest, "tipHandling");
    const surchargeAmountDto = extractNestedObject<TerminalProfileAdditionalAmountHandlingDto>(rest, "surchargeAmount");
    const taxAmountDto = extractNestedObject<TerminalProfileAdditionalAmountHandlingDto>(rest, "taxAmount");

    const cleanRest = Object.fromEntries(
        Object.entries(rest).filter(
            ([key]) =>
                !key.startsWith("terminalConfiguration") &&
                !key.startsWith("merchantReferenceNumber1") &&
                !key.startsWith("merchantReferenceNumber2") &&
                !key.startsWith("tipHandling") &&
                !key.startsWith("surchargeAmount") &&
                !key.startsWith("taxAmount"),
        ),
    );

    return {
        ...cleanRest,
        terminalConfiguration: terminalConfigurationDto,
        merchantReferenceNumber1: merchantReference1Dto,
        merchantReferenceNumber2: merchantReference2Dto,
        tipHandling: tipHandlingDto,
        surchargeAmount: surchargeAmountDto,
        taxAmount: taxAmountDto,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
